<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $t("shiftclose") }}
      </div>
      <router-link class="btn-blue" to="shifts-close"
        >{{ $t("shiftclose") }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="card-payment-contianer white-wrapper">
      <!-- <div class="row">
        <div class="col-4 d-flex align-items-center mb-3">
          <div class="mr-2">SSSSS: Float Amount :</div>
          <div class="input-material">
            <input type="text" disabled />
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-8">
              <div class="row mx-0">
                <div class="w-100">
                  <div class="d-flex flex-wrap">
                    <div class="btn-calc-container">
                      <button class="btn-calc"></button>
                    </div>
                    <div class="btn-calc-container">
                      <button class="btn-calc">C</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4 pl-0">
              <div class="d-flex flex-wrap">
                <div class="btn-auto-denomination-container">
                  <button class="btn-multiple d-flex justify-content-center align-items-center">
                    <div class="counts-money"></div>
                    <div class="close-btn">
                      <img
                        class="ml-1"
                        src="@/assets/img/icons/close-button.svg"
                        width="15"
                        height="15"
                      />
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4 d-flex align-items-center mb-3">
          <div class="mr-2">Credit Card :</div>
          <div class="input-material">
            <input type="text" disabled />
          </div>
        </div>
        <div class="col-4 d-flex align-items-center mb-3">
          <div class="mr-2">Debit Card :</div>
          <div class="input-material">
            <input type="text" disabled />
          </div>
        </div>
        <div class="col-4 d-flex align-items-center mb-3">
          <div class="mr-2">Mpesa :</div>
          <div class="input-material">
            <input type="text" disabled />
          </div>
        </div>
        <div class="col-12 d-flex border-top">
          <div class="d-flex mt-3">
            <div class="mr-2">Total INR :</div>
            <div class="input-material">
              <input type="text" />
            </div>
          </div>
        </div>
      </div>-->

      <div class="row">
        <ul class="list-unstyled">
          <li
            v-for="(PaymentItem, PaymentIndex) in getShiftClosePaymentTypes"
            :key="PaymentIndex"
            class="col-12 mb-3"
          >
            <div
              v-if="String(PaymentItem.pm_id) === '1'"
              class="input-material"
            >
              <input
                placeholder="."
                :value="PaymentItem.amount"
                type="number"
                step="any"
                class="form-control bg-white"
                @input="
                  oneditShiftClosePaymentHandler({
                    event: $event,
                    name: 'amount',
                    index: PaymentIndex,
                    value: $event.target.value
                  })
                "
              />
              <label
                :for="PaymentItem.pm_payment_mode"
                class="d-block small text-muted"
                >{{ PaymentItem.pm_payment_mode }}</label
              >
            </div>
            <div v-else>
              <label
                class="d-block small text-muted"
                :for="PaymentItem.pm_payment_mode"
                >{{ PaymentItem.pm_payment_mode }}</label
              >
              <div class="row">
                <div class="col-6">
                  <div class="input-material">
                    <input
                      class="form-control bg-white"
                      type="number"
                      :value="PaymentItem.no_of_slips"
                      placeholder="."
                      @input="
                        oneditShiftClosePaymentHandler({
                          event: $event,
                          name: 'no_of_slips',
                          index: PaymentIndex,
                          value: $event.target.value
                        })
                      "
                    />
                    <label>No Of Slips</label>
                  </div>
                </div>
                <div class="col-6">
                  <div class="input-material ml-1 h-auto">
                    <input
                      class="form-control bg-white"
                      type="number"
                      step="any"
                      :value="PaymentItem.amount"
                      placeholder="."
                      @input="
                        oneditShiftClosePaymentHandler({
                          event: $event,
                          name: 'amount',
                          index: PaymentIndex,
                          value: $event.target.value
                        })
                      "
                    />
                    <label>Amount</label>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li class="col-12 mb-4">
            <label for="Total" class="d-block small text-muted">Total</label>
            <input
              type="text"
              :value="shiftClosePaymentTotal"
              disabled
              class="form-control bg-white"
            />
          </li>
        </ul>
      </div>
      <section>
        <div class="col-md-12 text-center">
          <button @click.prevent.stop="OnFinalSubmit()" class="btn-blue">
            {{ $t("Close Shift") }}
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";

export default {
  name: "editShiftClose",
  data() {
    return {
      totalShiftClose: 0,
      paymentList: [],
      shiftClosePayload: {
        usl_id: null,
        user_shift_id: null,
        pos_user_id: null,
        login_date_time: null,
        logout_date_time: null
      }
    };
  },
  computed: {
    // ...mapGetters(["getUserShiftPaymentTypes"])
    getShiftClosePaymentTypes() {
      return this.paymentList;
    },
    shiftClosePaymentTotal() {
      return this.paymentList.reduce(
        (acc, { amount }) => acc + parseFloat(amount),
        0
      );
    }
  },
  beforeMount() {
    const { shift_id } = this.$route.query;

    if (shift_id) {
      this.getPaymentTypes();
      this.getShiftCloseDetails(shift_id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    getShiftCloseDetails: function(shift_id) {
      MasterService.OnGetSingleShiftClose({ shift_id })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.shiftClosePayload = {
                ...this.shiftClosePayload,
                ...data.Records[0],
                usl_id: data.Records[0].usl_id,
                user_shift_id: data.Records[0].user_shift_id,
                pos_user_id: data.Records[0].pos_user_id,
                login_date_time: data.Records[0].login_date_time,
                logout_date_time: data.Records[0].logout_date_time
              };
            }
          } else {
            //
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    oneditShiftClosePaymentHandler: function({ event, name, index, value }) {
      this.paymentList[index][name] =
        value && value.length > 0 && value.replace(/\s/g, "").length > 0
          ? parseFloat(value)
          : 0;
    },
    getPaymentTypes: function() {
      this.paymentList = [];
      let body = {
        // tableName: "ms_payment_modes",
        // pm_is_active: "Y",
        bs_id: 1
      };
      MasterService.GetPaymentModes(body)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              // this.paymentList =
              data.Records.map(x => {
                x["no_of_slips"] = 0;
                x["amount"] = 0;
                this.paymentList.push(x);
                return x;
              });
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(this.AdminError);
        });
    },
    OnFinalSubmit: function() {
      let payload = {
        ...this.shiftClosePayload,
        scr_total_amount_collected: this.shiftClosePaymentTotal,
        paymentList: this.paymentList
      };
      MasterService.OnShiftClose(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.$router.replace({
              path: "/cinema-manager/shifts-close"
            });
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ShiftCloseComponent/editShiftClose.vue